import { forwardRef } from "react";
import { UpdatedCommentsPanel } from "./UpdatedCommentsPanel";
import { ScrollArea } from "@/components/ui/scroll-area";

interface TextSelection {
  start: number;
  end: number;
  text: string;
  originalText: string;
}

interface Comment {
  id: string;
  number: number;
  text: string;
  color: string;
  textSelections: TextSelection[];
  isGeneral: boolean;
}

interface CommentsListCardProps {
  comments: Comment[];
  onAddComment: (text: string) => void;
  onDeleteComment: (commentId: string) => void;
  onEditComment: (commentId: string, newText: string) => void;
  onAddAttachment?: (files: File[]) => void;
  selectedText: string;
  highlightedCommentId: string | null;
  isComposingComment: boolean;
  setIsComposingComment: (isComposing: boolean) => void;
}

export const CommentsListCard = forwardRef<HTMLDivElement, CommentsListCardProps>(
  ({ comments, onAddComment, onDeleteComment, onEditComment, onAddAttachment, selectedText, highlightedCommentId, isComposingComment, setIsComposingComment }, ref) => {
    return (
      <div ref={ref} className="h-full border-l bg-background flex flex-col">
        <UpdatedCommentsPanel
          comments={comments}
          onAddComment={onAddComment}
          onDeleteComment={onDeleteComment}
          onEditComment={onEditComment}
          onAddAttachment={onAddAttachment}
          selectedText={selectedText}
          highlightedCommentId={highlightedCommentId}
          isComposingComment={isComposingComment}
          setIsComposingComment={setIsComposingComment}
        />
      </div>
    );
  }
);

CommentsListCard.displayName = "CommentsListCard";
